module.exports = __webpack_public_path__ + "img/en.c6cd26ba.png";